import { queryOptions, useQuery } from "@tanstack/react-query"

import type { FullSession } from "../types"
import type { QueryConfig } from "@/lib/react-query"

import { api } from "@/lib/api-client"
import { queryKeys } from "@/lib/query-keys"

import { useAIParserSession } from "./use-ai-parser-session"

function getFullSession(sessionId: string): Promise<FullSession> {
  return api.get(`/get-session?session_id=${sessionId}`)
}

export function getFullSessionQueryOptions(sessionId: string) {
  return queryOptions({
    queryKey: queryKeys.fullSession(sessionId),
    queryFn: () => getFullSession(sessionId),
  })
}

type UseGetFullSessionProps = {
  queryConfig?: QueryConfig<typeof getFullSessionQueryOptions>
}

export function useGetFullSession({ queryConfig }: UseGetFullSessionProps) {
  const { currentSessionId } = useAIParserSession()

  return useQuery({
    ...getFullSessionQueryOptions(currentSessionId ?? ""),
    enabled: !!currentSessionId,
    ...queryConfig,
  })
}
